import React, {useState, useEffect, useRef} from "react";
import {InfoIcon, YoutubeIcon, ChevronIcon, SettingsIcon, LinksIcon} from "./icons";

const categoryLabels = {
    admin: 'Settings',
    help_center: 'Help center',
    youtube: 'Video tutorials',
    other: 'Other pages'
};

const CategoryIcon = ({category}) => {
    switch (category) {
        case 'youtube':
            return <YoutubeIcon />
        case 'help_center':
            return <InfoIcon />
        case 'other':
            return <LinksIcon />
        default:
            return <SettingsIcon />
    }
};


export const SearchResultGroup = ({category, items, defaultOpen = false, dropdown = false, isOpen: isOpenProp, onToggle, onClose}) => {
    const [openLocal, setOpenLocal] = useState(defaultOpen);
    const [alignRight, setAlignRight] = useState(false);
    const groupRef = useRef(null);

    const open = dropdown ? isOpenProp : openLocal;

    const handleToggle = dropdown ? () => {
        if (groupRef.current) {
            const rect = groupRef.current.getBoundingClientRect();
            const parentRect = groupRef.current.parentElement?.getBoundingClientRect();
            if (parentRect) {
                setAlignRight((rect.left + rect.width / 2) > (parentRect.left + parentRect.width / 2));
            }
        }
        onToggle();
    } : () => setOpenLocal(v => !v);

    return (
        <div ref={groupRef} className={`sb-search-results--group ${open ? ' sb-search-results--group_open' : ''}${dropdown ? ' sb-search-results--group_dropdown' : ''} ${category}`}>
            <button
                type="button"
                className="btn btn-secondary--outline sb-search-results--group-header"
                onClick={handleToggle}
            >
                <CategoryIcon category={category} />
                <span className="sb-search-results--group-title">{categoryLabels[category] || category}</span>
                {/*<span className="sb-search-results--group-count">{items.length}</span>*/}
                <ChevronIcon />
            </button>
            {open && (
                <div className={`sb-search-results--group-body ${alignRight ? 'align-right' : 'align-left'}`}>
                    {items.map((item, idx) => (
                        <a key={idx} href={item.url} target="_blank" rel="noopener noreferrer" className={`sb-search-result--link sb-search-result--${category}`} onClick={dropdown ? onClose : undefined}>
                            <CategoryIcon category={category} />
                            <span className="sb-search-result--text">{item.title}</span>
                        </a>
                    ))}
                </div>
            )}
        </div>
    );
};

export const SearchResults = ({results, defaultOpen = false, dropdown = false}) => {
    const [openCategory, setOpenCategory] = useState(null);
    const containerRef = useRef(null);

    useEffect(() => {
        if (!dropdown) return;
        const handler = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                setOpenCategory(null);
            }
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, [dropdown]);

    const grouped = {};
    results.forEach(item => {
        if (!grouped[item.category]) grouped[item.category] = [];
        grouped[item.category].push(item);
    });

    return (
        <div className="sb-search-results" ref={dropdown ? containerRef : null}>
            <div className="sb-search-results--title">Related resources</div>
            {Object.keys(grouped).map(category => (
                <SearchResultGroup
                    key={category}
                    category={category}
                    items={grouped[category]}
                    defaultOpen={defaultOpen}
                    dropdown={dropdown}
                    isOpen={dropdown ? openCategory === category : undefined}
                    onToggle={dropdown ? () => setOpenCategory(prev => prev === category ? null : category) : undefined}
                    onClose={dropdown ? () => setOpenCategory(null) : undefined}
                />
            ))}
        </div>
    );
};
